import { render, staticRenderFns } from "./RegistryObjectDeleteDialog.vue?vue&type=template&id=ec296780&"
import script from "./RegistryObjectDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./RegistryObjectDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RegistryObjectDeleteDialog.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports